import React from "react";
function Breadcrumbs(props:any) {
  return (
    <div className="App">
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb">
        <li className="breadcrumb-item">
            {/*<a href="#"> */}
              <i className="fa fa-fw fa-home ml-1 fa-1x"></i>
            {/* </a>*/}
          </li>
          <li className="breadcrumb-item">
             {/*<a href="#"> */}
              {props.path}
            {/* </a>*/}
          </li>
          {/* <li className="breadcrumb-item">
            <a href="#"> Apps / Games </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            View
          </li> */}
        </ol>
      </nav>
    </div>
  );
}

export default Breadcrumbs;
